import { lineaTokens } from '@pancakeswap/tokens'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { Strategy, VaultConfig } from '../../types'
import { MANAGER } from '../managers'

export const vaults: VaultConfig[] = [
  {
    id: 1,
    idByManager: 1,
    name: 'TEAHOUSE',
    bCakeWrapperAddress: '0x416dC8c34d1A4812dAc2F58fF1f428ccf5Ae8b20',
    address: '0x416dC8c34d1A4812dAc2F58fF1f428ccf5Ae8b20',
    vaultAddress: '0x07811284e36fDc45f65cd56FC7c6929855d6A0cc',
    adapterAddress: '0x9EBac6d8EA9DB9E5a9cCa6694C45F3372FDCD683',
    currencyA: lineaTokens.usdc,
    currencyB: lineaTokens.weth,
    earningToken: lineaTokens.cake,
    feeTier: FeeAmount.LOW,
    strategy: Strategy.SSS,
    manager: MANAGER.TEAHOUSE,
    isSingleDepositToken: false,
    allowDepositToken0: true,
    allowDepositToken1: true,
    managerInfoUrl: 'https://teahouse.finance/',
    strategyInfoUrl: 'https://docs.teahouse.finance/teahouse-finance-1/lp-vaults/strategies',
    learnMoreAboutUrl: 'https://docs.teahouse.finance/teahouse-finance-1/managed-vaults/about-managed-vaults',
  },
  {
    id: 2,
    idByManager: 2,
    name: 'TEAHOUSE',
    bCakeWrapperAddress: '0x4fA864195287a71aa90D1d842209b8fb0EC3aBEc',
    address: '0x4fA864195287a71aa90D1d842209b8fb0EC3aBEc',
    vaultAddress: '0x0F3CC3Ea42b989323e7c7e499b5B6A343eA55c18',
    adapterAddress: '0x11D2deE14c3cF806f29D7865744813B1aeFcB430',
    currencyA: lineaTokens.wbtc,
    currencyB: lineaTokens.weth,
    earningToken: lineaTokens.cake,
    feeTier: FeeAmount.LOW,
    strategy: Strategy.APS,
    manager: MANAGER.TEAHOUSE,
    isSingleDepositToken: false,
    allowDepositToken0: true,
    allowDepositToken1: true,
    managerInfoUrl: 'https://teahouse.finance/',
    strategyInfoUrl: 'https://docs.teahouse.finance/teahouse-finance-1/lp-vaults/strategies',
    learnMoreAboutUrl: 'https://docs.teahouse.finance/teahouse-finance-1/managed-vaults/about-managed-vaults',
  },
  {
    id: 3,
    idByManager: 3,
    name: 'TEAHOUSE',
    bCakeWrapperAddress: '0x051aE581d92096054C121ACe5891Ce6ff6188581',
    address: '0x051aE581d92096054C121ACe5891Ce6ff6188581',
    vaultAddress: '0xd4E10dd0c0e64C5F6EB134E7D2F2D43f82D8DC00',
    adapterAddress: '0x2BA2F52f7f5E2a580Ca00Cdb2D2F9C6dEB54F994',
    currencyA: lineaTokens.usdc,
    currencyB: lineaTokens.usdt,
    earningToken: lineaTokens.cake,
    feeTier: FeeAmount.LOWEST,
    strategy: Strategy.SSS,
    manager: MANAGER.TEAHOUSE,
    isSingleDepositToken: false,
    allowDepositToken0: true,
    allowDepositToken1: true,
    managerInfoUrl: 'https://teahouse.finance/',
    strategyInfoUrl: 'https://docs.teahouse.finance/teahouse-finance-1/lp-vaults/strategies',
    learnMoreAboutUrl: 'https://docs.teahouse.finance/teahouse-finance-1/managed-vaults/about-managed-vaults',
  },
  {
    id: 4,
    idByManager: 4,
    name: 'TEAHOUSE',
    bCakeWrapperAddress: '0x4283BCB20b96a5c71b6E9c7D1596de4Af5564f26',
    address: '0x4283BCB20b96a5c71b6E9c7D1596de4Af5564f26',
    vaultAddress: '0x8FCc61e802c6356486e37d45b53D212af34Cc2ae',
    adapterAddress: '0xd8213C977D697FbdF7bfa0272Add47266A283023',
    currencyA: lineaTokens.wstETH,
    currencyB: lineaTokens.weth,
    earningToken: lineaTokens.cake,
    feeTier: FeeAmount.LOW,
    strategy: Strategy.SSS,
    manager: MANAGER.TEAHOUSE,
    isSingleDepositToken: false,
    allowDepositToken0: true,
    allowDepositToken1: true,
    managerInfoUrl: 'https://teahouse.finance/',
    strategyInfoUrl: 'https://docs.teahouse.finance/teahouse-finance-1/lp-vaults/strategies',
    learnMoreAboutUrl: 'https://docs.teahouse.finance/teahouse-finance-1/managed-vaults/about-managed-vaults',
  },
]
